import React from 'react';
import Seo from '@/components/Seo';

export default function PrivacyPage() {
  return (
    <>
      <Seo title="Privacy Policy | Tri-Cities Water Damage Help" description="Privacy information for Tri-Cities Water Damage Help." noindex />
      <section className="py-16 sm:py-20">
        <div className="container-page max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-wider text-water-strong">Privacy Policy</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-primary">How we handle your information</h1>
          <div className="mt-8 space-y-6 text-sm leading-7 text-muted-foreground">
            <p>When you submit a help request, we collect the information you provide so the request can be processed and connected with an appropriate restoration provider serving the Tri-Cities.</p>
            <p>Information submitted through the site may include your name, phone number, city, type of water damage and details you choose to provide about the situation.</p>
            <p>We use this information to respond to your request, route it to a relevant provider, maintain service records and understand how the website is used. We do not sell personal information for unrelated marketing purposes.</p>
            <p>Website analytics and call-click tracking may be used to understand site performance and improve the service. Additional analytics or call-tracking tools will be identified here when they are activated.</p>
            <p>If you have questions about information submitted through this website, use the Contact page.</p>
          </div>
        </div>
      </section>
    </>
  );
}
